// extracted by mini-css-extract-plugin
export default {"linkPreview":"LinkPreview_linkPreview__55HuM"};